import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { LocalizeConfig, TRANSLATE, TRANSLOCO_FOR_ROOT_GUARD } from './interfaces';
import { provideTranslocoConfig } from '@skyeng/libs/shared/i18n';

@NgModule({
  exports: [TranslocoModule],
  providers: [],
})
export class TranslocoRootModule {
  static forRoot(config: LocalizeConfig): ModuleWithProviders<TranslocoModule> {
    return {
      ngModule: TranslocoRootModule,
      providers: [
        provideTranslocoConfig({
          availableLangs: TRANSLATE.LANGS_AVAILABLE,
          defaultLang: TRANSLATE.LANG_DEFAULT,
          fallbackLang: TRANSLATE.LANG_FALLBACK,
          prodMode: config.isProduction,
        }),
        {
          provide: TRANSLOCO_FOR_ROOT_GUARD,
          useFactory: provideForRootGuard,
          deps: [TranslocoRootModule],
        },
      ],
    };
  }
}

function provideForRootGuard(translocoRootModule: TranslocoRootModule): string {
  if (translocoRootModule) {
    throw new Error('TranslocoRootModule.forRoot() called twice.');
  }
  return 'guarded';
}
